module.exports = __webpack_public_path__ + "static/media/f_man.20b27179.png";